import assignStudentsToClass from "../../mp-core/helpers/users/manageUsers/assignStudentsToClass"
import { ClassType, Student } from "../../mp-database"

export const assignStudents = async (
  notAssigned: Student[],
  assigned: Student[],
  classRecord: ClassType,
  studentsData: { schoolYear: number; courseId?: string }
) => {
  const { schoolYear, courseId } = studentsData

  await assignStudentsToClass(
    notAssigned,
    classRecord,
    false,
    schoolYear,
    courseId
  )
  await assignStudentsToClass(assigned, classRecord, true, schoolYear, courseId)
}
